import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { authConfig } from "../../auth.config";
import { AppConstants } from "../constants/constants";

import {
  Http,
  RequestOptions,
  Headers,
  Request,
  RequestMethod,
  URLSearchParams,
  QueryEncoder
} from "@angular/http";
import { SpinnerService } from "../../components/spinner/spinner.service";
import { ProfileModel } from "../../models/profile/profile.model";


export class CustomQueryEncoderHelper extends QueryEncoder {
  encodeKey(k: string): string {
      k = super.encodeKey(k);
      return k.replace(/\+/gi, '%2B');
  }
  encodeValue(v: string): string {
      v = super.encodeValue(v);
      return v.replace(/\+/gi, '%2B');
  }
}



@Injectable()
export class AuthService {
  constructor(
    private http: Http,
    private spinnerService: SpinnerService
  ) {}


  login(loginModel: any) {
    let headers = new Headers({
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'TimezoneOffsetUtcLocal' : new Date().getTimezoneOffset().toString()
    });

    let params: URLSearchParams = new URLSearchParams('', new CustomQueryEncoderHelper());
    params.append('client_id', authConfig.client_id);
    params.append('client_secret', authConfig.client_secret);
    params.append('scope', environment.authConfig.scope);
    params.append('username', loginModel.UserName);
    params.append('password', loginModel.Password);
    params.append('grant_type', "password");


    this.spinnerService.show();

    return this.http.post(authConfig.authority, params.toString(), { headers: headers })
    .map((res) => {
        if (res) {
          const data = res.json();
          this.storeAuthorizeLocalStorage(data);
        }
      })
      .finally(() => {
        this.spinnerService.hide();
      });;
  }


  refreshToken() {
    const refresh_token = localStorage.getItem(AppConstants.localStorage.state);
    const data = {
      grant_type: "refresh_token",
      refresh_token: refresh_token,
    };
    const httpParams = this.setHttpParams(data);
    const options = this.setRequestOptions(httpParams);

    return this.execute(options);
  }

  private setRequestOptions(payload: any) {
    let headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append("Accept", "application/json");
    headers.append(
      "TimezoneOffsetUtcLocal",
      new Date().getTimezoneOffset().toString()
    );

    let options = new RequestOptions({
      method: RequestMethod.Post,
      url: authConfig.authority,
      headers: headers,
      body: payload.toString(),
    });
    return options;
  }

  private setHttpParams(data: any) {
    const params = new URLSearchParams()
    params.set("client_id", authConfig.client_id)
    params.set("client_secret", authConfig.client_secret);
    for (const key in data) {
      if (
        data[key] != null &&
        data[key] != undefined &&
        data[key] != NaN &&
        data.hasOwnProperty(key)
      ) {
        let strParams = data[key].toString();
        params.set(key, strParams);
      }
    }
    return params;
  }
  private execute(options: any) {
    this.spinnerService.show();
    return this.http
      .request(new Request(options))
      .map((res) => {
        if (res) {
          const data = res.json();
          this.storeAuthorizeLocalStorage(data);
        }
      })
      .finally(() => {
        this.spinnerService.hide();
      });
  }

  storeAuthorizeLocalStorage(data: any) {
    var tokenDecoded = this.parseJwt(data.access_token);
    if (data != null) {
      try {
        const profile : ProfileModel = {
          name: tokenDecoded.name,
          given_name: tokenDecoded.given_name,
          family_name: tokenDecoded.family_name,
          preferred_username: tokenDecoded.preferred_username,
          email: tokenDecoded.email,
          email_verified: tokenDecoded.email_verified,
          sub: tokenDecoded.sub,
          exp: tokenDecoded.exp,
          scope: tokenDecoded.scope,
          isActiveNewsFeed: tokenDecoded.isActiveNewsFeed
        };

        const id_token = tokenDecoded["AspNet.Identity.SecurityStamp"];
        localStorage.setItem("profile", JSON.stringify(profile));
        localStorage.setItem(
          AppConstants.activeLink.userId,
          profile["sub"].toString()
        );
        localStorage.setItem(
          AppConstants.localStorage.token,
          data.access_token
        );
        localStorage.setItem(AppConstants.localStorage.idToken, id_token);
        localStorage.setItem(
          AppConstants.localStorage.expireTime,
          data.expires_in.toString()
        );
        localStorage.setItem(
          AppConstants.localStorage.tokenType,
          data.token_type
        );
        localStorage.setItem(AppConstants.localStorage.scope, profile.scope);
        localStorage.setItem(
          AppConstants.localStorage.state,
          data.refresh_token
        );
        localStorage.setItem(AppConstants.localStorage.sessionState, "");
        localStorage.setItem(
          AppConstants.localStorage.userAccount,
          profile["preferred_username"]
        );
        // set expire date
        let expireDate = new Date();
        expireDate.setSeconds(
          expireDate.getSeconds() +
            parseInt(localStorage.getItem(AppConstants.localStorage.expireTime))
        );
        localStorage.setItem(
          AppConstants.localStorage.expireDate,
          expireDate.toString()
        );

        // set user info
        if (profile != null) {
          localStorage.setItem(
            AppConstants.localStorage.firstName,
            profile[AppConstants.localStorage.firstName]
          );
          localStorage.setItem(
            AppConstants.localStorage.lastName,
            profile[AppConstants.localStorage.lastName]
          );
          localStorage.setItem(
            AppConstants.localStorage.userAccount,
            profile["preferred_username"]
          );
          localStorage.setItem(
            AppConstants.localStorage.userName,
            profile[AppConstants.localStorage.firstName] +
              " " +
              profile[AppConstants.localStorage.lastName]
          );
          localStorage.setItem(
            AppConstants.localStorage.isActiveNewsFeed,
            profile[AppConstants.localStorage.isActiveNewsFeed]
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/services/auth.service.ts